var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":_vm.color,"name":_vm.icon,"scale":_vm.scale}})}
var staticRenderFns = []

export { render, staticRenderFns }